import {
  SwapOutlined,
  CaretDownOutlined,
  DashboardOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { Space, Input } from "antd";
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
import React, { useEffect, useState, useRef } from "react";
import { DatePicker } from "antd";
import moment from "moment";
import { get, post } from "../Libraries/Ajax/HttpService";
import { useNavigate } from "react-router-dom";
import { makeDisabledDatePastNDays } from "../utils/dateLimits";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  LineChart,
  Tooltip,
  Line,
  Label,
  ResponsiveContainer,
} from "recharts";
import { Spin, Tooltip as tooltip } from "antd";
import { toast } from "react-toastify";
import back from "../assets/images/back.svg";
import { Collapse } from "antd";
import { useDistrict } from "../utils/DistrictContext";
import VirtualMeters from "../components/VirtualMeters";
const { Panel } = Collapse;

const colorMapping = {
  NPI: "#ff0000", // Red
  PD: "#00ff00", // Green
  PF: "#0000ff", // Blue
  PI: "#ff00ff", // Purple
};

const colorPalette = [
  "#ff0000",
  "#00ff00",
  "#0000ff",
  "#ff00ff",
  "#ffa500",
  "#800080",
];

function WaterMeterReading() {
  const { RangePicker } = DatePicker;
  const [water, setWater] = useState(true);
  const [wateragg, setWateragg] = useState(false);
  const [waterreading, setWaterReading] = useState(false);
  const [slvalue, setSlvalue] = useState(1);
  const [defaultOption, setDefaultOption] = useState("Past Month");
  const [optiononenew, setOptiononenew] = useState(["Day"]);
  const [parameterone, setParameterone] = useState(null);
  const [parametertwo, setParametertwo] = useState(null);
  const [value, setvalue] = useState(1);
  const [slmax, setSlmax] = useState(4);
  const [userid_meterlisting, setUserId_meterlisting] = useState(null);

  const [activeKeys, setActiveKeys] = useState([]);
  const [headings_meterlisting, setHeadings_meterlisting] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sideMenuLoader, setSideMenuLoader] = useState(false);

  const domEl = useRef(null);
  const [selectedMeters, setSelectedMeters] = useState([]);
  const [chartData, setChartData] = useState([]);

  const { selectedDistrict } = useDistrict();

  const navigate = useNavigate();
  const districtRef = useRef(selectedDistrict);
  // Disable any day >= (today - 2 days)
  const disabledDate = makeDisabledDatePastNDays(2);
  // Add this with your other useState hooks
  const [searchTerm, setSearchTerm] = useState("");
  useEffect(() => {
    var user = JSON.parse(localStorage.getItem("MCData"));
    // console.log("UserId Check::", user?.userid)
    if (user?.userid) {
      setUserId_meterlisting(user?.userid);
    }
    setSelectedMeters([]);
    setChartData([]);
  }, [selectedDistrict]);

  useEffect(() => {
    if (
      defaultOption === "Past Month" ||
      defaultOption === "Past 3 Months" ||
      defaultOption === "Past Year"
    ) {
      setOptiononenew("Week");
    }
  }, [defaultOption]);

  const onRedirection = (event) => {
    // window.history.back();
    navigate(-1);
  };

  const onselectClicks = () => {
    setWater(true);
    setWateragg(false);
    navigate("/Waters");
  };
  const onselectClickss = () => {
    setWater(false);
    setWateragg(true);
    navigate("/Wateragg");
  };
  const onChangeToWaterMeterReading = () => {
    setWater(false);
    setWateragg(false);
    setWaterReading(true);
    navigate("/watermeterreadings");
  };

  const onMouseClick_DateRange = (event) => {
    setSlvalue(1);
    setDefaultOption(event.target.value);
    if (event.target.value == "Past Day") {
      setOptiononenew("Hour");
    } else if (
      event.target.value == "Past Year" ||
      event.target.value == "Past Month" ||
      event.target.value == "Past 3 Months" ||
      event.target.value == "Custom"
    ) {
      setOptiononenew("Day");
    } else if (event.target.value == "Past Week") {
      setOptiononenew("Day");
    }
  };
  

  const onchange_Day = (value, dateString) => {
    const start = dateString[0];
    const end = dateString[1];

    setParameterone(start);
    setParametertwo(end);

    const diffDays = (new Date(end) - new Date(start)) / (1000 * 60 * 60 * 24);

    
    const diff =
      (new Date(end) - new Date(start)) / (1000 * 60 * 60 * 24) / 7 / 2;

    const diffs = new Date(end) - new Date(start);

    setvalue(
      Math.floor((new Date(end) - new Date(start)) / (1000 * 60 * 60 * 24) / 7),
    );

    setSlmax(diff);
  };

  const radioChange = (event) => {
    event.stopPropagation();
    setSlvalue(1);
    setOptiononenew(event.target.id);
  };

  const sliderChange = (event) => {
    setSlvalue(event.target.value);
  };

  const handleToggle = (keys) => {
    setActiveKeys(keys);
  };

  useEffect(() => {
    const fetchData_MeterList = async () => {
      setSideMenuLoader(true);
      try {
        let response;
        if (defaultOption !== "Custom") {
          response = await get(
            `apis/water/aggregate/by_flow/meter_list?option=${optiononenew}&range_option=${defaultOption}&user_id=${userid_meterlisting}`,
          );
        } else {
          if (parameterone || parametertwo) {
            response = await get(
              `apis/water/aggregate/by_flow/meter_list?option=${optiononenew}&range_option=${defaultOption}&user_id=${userid_meterlisting}&start=${parameterone}&end=${parametertwo}`,
            );
          }
        }
        const { water_flow } = response.data.data;

        // Process and map the data to headings and meters
        const mappedHeadings = Object.keys(water_flow).map((categoryCode) => {
          const category = water_flow[categoryCode];
          return {
            code: categoryCode,
            title: category.category_name,
            meters: category.water_data.map((meter) => ({
              meter_id: meter.meter_id,
              register_number: meter.register_number || " ",
              flow: meter.flow,
              overided_name: meter.overided_name,
            })),
          };
        });

        setHeadings_meterlisting(mappedHeadings);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setSideMenuLoader(false);
      }
    };

    if (userid_meterlisting) {
      fetchData_MeterList();
    }
  }, [
    defaultOption,
    optiononenew,
    userid_meterlisting,
    parameterone,
    parametertwo,
    selectedDistrict,
  ]);

  const handleMeterSelection = (categoryCode, meterId, registerNumber) => {
    const meterKey = `${meterId},${registerNumber.trim()}`;

    setSelectedMeters((prevSelectedMeters) => {
      // Count the total number of selected meters across all categories
      const totalSelectedMeters = prevSelectedMeters.reduce(
        (count, item) => count + item.meters.length,
        0,
      );

      // Check if the selected meter count is already 4
      if (totalSelectedMeters >= 4) {
        const categoryIndex = prevSelectedMeters.findIndex(
          (item) => item.code === categoryCode,
        );
        const meters =
          categoryIndex >= 0 ? prevSelectedMeters[categoryIndex].meters : [];

        // If the meter is already selected, allow it to be deselected
        if (!meters.includes(meterKey)) {
          // Return the previous state without changes if attempting to select more than 4 meters
          toast.warning("You can select only 4 meters at a time");
          return prevSelectedMeters;
        }
      }

      // Proceed with normal selection logic
      const categoryIndex = prevSelectedMeters.findIndex(
        (item) => item.code === categoryCode,
      );

      if (categoryIndex >= 0) {
        const meters = [...prevSelectedMeters[categoryIndex].meters];
        const meterIndex = meters.indexOf(meterKey);

        // If meter is already selected, remove it
        if (meterIndex >= 0) {
          meters.splice(meterIndex, 1);
        } else {
          // If not selected, add it
          meters.push(meterKey);
        }

        // Remove the category if no meters are selected
        if (meters.length === 0) {
          return prevSelectedMeters.filter(
            (item) => item.code !== categoryCode,
          );
        }

        // Update the selected meters for the category
        const updatedSelection = [...prevSelectedMeters];
        updatedSelection[categoryIndex] = {
          code: categoryCode,
          meters,
        };
        return updatedSelection;
      } else {
        // If the category is not in the array, add it with the meter
        return [
          ...prevSelectedMeters,
          {
            code: categoryCode,
            meters: [meterKey],
          },
        ];
      }
    });
  };

  const handleClearCategory = (categoryCode) => {
    setSelectedMeters((prev) =>
      prev.filter((item) => item.code !== categoryCode),
    );
  };

  
  useEffect(() => {
    if (searchTerm.length > 0) {
      // Expand all categories that have matching results
      const keysToExpand = filteredHeadings.map((_, index) => index.toString());
      setActiveKeys(keysToExpand);
    }
  }, [searchTerm]); // filteredHeadings is derived from searchTerm
  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    const submitMeters = async () => {
      if (districtRef.current !== selectedDistrict) {
        districtRef.current = selectedDistrict;
        setChartData([]);
        return;
      }

      if (!selectedMeters || selectedMeters.length === 0) {
        setChartData([]);
        setLoading(false);
        return;
      }

      setLoading(true);

      try {
        const params = { selected_meters: selectedMeters };
        let response;

        const config = { signal };

        if (defaultOption !== "Custom") {
          response = await post(
            `apis/water/aggregate/by_flow?option=${optiononenew}&range_option=${defaultOption}&interval=${slvalue}`,
            params,
            config,
          );
        } else {
          response = await post(
            `apis/water/aggregate/by_flow?option=${optiononenew}&range_option=${defaultOption}&interval=${slvalue}&start=${parameterone}&end=${parametertwo}`,
            params,
            config,
          );
        }

        const waterFlowData = response.data.data.water_flow;
        const arryDatas_WaterMeter = waterFlowData.map((item) => {
          let name = item[0].flow_date_check;
          const meterData = Object.fromEntries(
            item?.map(({ flow, meter }) => [meter, flow]),
          );
          return { name, ...meterData };
        });

        setChartData(arryDatas_WaterMeter);
      } catch (error) {
        if (error.name === "AbortError") {
          console.log("Request was cancelled");
        } else {
          console.error("Error calling the API:", error);
        }
      } finally {
        if (!signal.aborted) setLoading(false);
      }
    };

    submitMeters();

    return () => controller.abort();
  }, [
    selectedMeters,
    optiononenew,
    defaultOption,
    slvalue,
    parameterone,
    parametertwo,
    selectedDistrict,
    headings_meterlisting,
  ]);
  // Add this logic before the return statement
  const filteredHeadings = headings_meterlisting
    .map((category) => {
      return {
        ...category,
        meters: category.meters.filter(
          (meter) =>
            meter.meter_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
            (meter.overided_name &&
              meter.overided_name
                .toLowerCase()
                .includes(searchTerm.toLowerCase())) ||
            (meter.register_number &&
              meter.register_number
                .toLowerCase()
                .includes(searchTerm.toLowerCase())),
        ),
      };
    })
    .filter((category) => category.meters.length > 0);
  const selectedMeterKeys = selectedMeters
    .map(
      (item) => item.meters.map((meter) => meter.split(",")[0].trim()), // Extract meter_id from selected meters
    )
    .flat();

  // Create a color map based on selected meters
  const meterColorMap = selectedMeterKeys.reduce((acc, meterKey, index) => {
    acc[meterKey] = colorPalette[index % colorPalette.length]; // Assign unique color to each selected meter
    return acc;
  }, {});

  console.log("chartData::>>", chartData);
  console.log("headings_meterlisting::>>", headings_meterlisting);
  console.log("selectedMeters::", selectedMeters);

  return (
    <>
      {/* <head>
        <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"}  </title></head> */}
      <Header />
      <Main>
        <div className="waterDetails">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <img
                src={back}
                alt=""
                style={{ width: "10px", cursor: "pointer" }}
                onClick={onRedirection}
              />
              {/* <ArrowLeftOutlined onClick={onRedirection} /> */}
              {/* <h3 className="mb-0">Water Usage</h3> */}
              <div className="d-flex align-items-center">
                <div
                  className="new-box-padding    align-self-center c-pointer "
                  onClick={onselectClicks}
                  style={{
                    borderBottom: "2px solid #ccc",
                  }}
                >
                  Water Usage
                  <tooltip title="Shows water consumption per meter for the selected date range. Compare usage of up to 8 meters at once.">
                    <InfoCircleOutlined
                      className="ms-1 text-blue"
                      style={{ fontSize: "14px" }}
                    />
                  </tooltip>
                </div>
                <div
                  className=""
                  style={{ width: "2px", height: "25px", background: "#ccc" }}
                ></div>
                <div
                  className="new-box-padding   align-self-center c-pointer "
                  onClick={onselectClickss}
                  style={{
                    borderBottom: "2px solid #ccc",
                  }}
                >
                  Aggregate Usage
                  <tooltip title="Shows total water consumption per account for the selected date range. Use the category toggle to view usage by meter category within each account.">
                    <InfoCircleOutlined
                      className="ms-1 text-blue"
                      style={{ fontSize: "14px" }}
                    />
                  </tooltip>
                </div>
                <div
                  className="Shows total water consumption per account for the selected date range. Use the category toggle to view usage by meter category within each account."
                  style={{ width: "2px", height: "25px", background: "#ccc" }}
                ></div>
                <div
                  className="new-box-padding text-blue  align-self-center c-pointer "
                  onClick={onChangeToWaterMeterReading}
                  style={{
                    borderBottom: "2px solid #1998f0",
                    borderRadius: "0",
                  }}
                >
                  Meters By Flow
                  <tooltip title="Lists meters in descending order of total flow for the selected date range and preselected meter categories. View water consumption trends over the selected period.">
                    <InfoCircleOutlined
                      className="ms-1 text-blue"
                      style={{ fontSize: "14px" }}
                    />
                  </tooltip>
                </div>
              </div>
            </div>
          </div>

          <div className="row m-0 row-cols-4 g-3 align-items-center w-100 mt-2 justify-content-between">
            <div className="col-12 col-lg-3 ps-0">
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <h3
                  className="my-0"
                  style={{
                    margin: "0rem",
                    padding: "0.25rem 0.5em",

                    // border: '1px solid #D9D9D9',

                    fontSize: "fs-26",
                    // width: '400px',
                    color: "#1998f0",
                    height: "50px",
                  }}
                >
                  {" "}
                  Meters{" "}
                </h3>
              </div>
            </div>

            <div className="d-flex align-items-center meter-width">
              <div className="col mt-0 me-4">
                <div className="w-100 text-blue">Search For Meter</div>
                <div className="w-100">
                  <Input
                    placeholder="Search Meters"
                    prefix={<DashboardOutlined style={{ color: "#bfbfbf" }} />}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    allowClear
                    style={{ height: "50px", borderRadius: "4px" }}
                  />
                </div>
              </div>
              <div className="col mt-0 me-4">
                <div className="w-100 text-blue">Date Range</div>
                <div
                  id="1st"
                  className="w-100 d-flex selectCalender ms-auto mt-0 water-space align-items-center
                            justify-content-center"
                >
                  <div className="d-flex w-100">
                    <div className="fs-26 fw-bold d-flex w-100 water">
                      <select
                        name="All meters"
                        id="selector"
                        className="box"
                        onChange={onMouseClick_DateRange}
                      >
                        <option value="Past Year">Past 365 Days</option>
                        <option value="Past 3 Months">Past 90 Days </option>
                        <option value="Past Month" selected>
                          Past 30 Days
                        </option>
                        <option value="Past Week">Past 7 Days</option>
                        <option value="Past Day">Past Day</option>
                        <option value="Custom">Custom</option>
                      </select>
                    </div>
                    <Space
                      direction="horizontal"
                      size={1}
                      className="custom-date"
                    >
                      {defaultOption === "Custom" ? (
                        <RangePicker
                          onChange={onchange_Day}
                          disabledDate={disabledDate}
                          separator={<SwapOutlined />}
                        />
                      ) : (
                        ""
                      )}
                    </Space>
                  </div>
                </div>
              </div>

              <div className="col mt-0">
                <div className="w-100 text-blue">Interval</div>
                <div
                  className="dropdown intervaldropdown"
                  style={{ height: "50px" }}
                >
                  <button
                    className="btn w-100 text-left-content d-flex justify-content-between align-items-center"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {optiononenew === "Months"
                      ? optiononenew
                      : slvalue + " " + optiononenew}
                    <span className="d-block" style={{ lineHeight: "0" }}>
                      {" "}
                      <CaretDownOutlined />{" "}
                    </span>
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li className="interdrop">
                      {defaultOption == "Past Week" ? (
                        <>
                          <div class="form-check d-flex align-items-center">
                            <Input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="Day"
                              onClick={radioChange}
                              defaultChecked="true"
                            />
                            <label
                              className="form-check-label"
                              for="Day"
                              onClick={radioChange}
                            >
                              Days
                            </label>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {defaultOption == "Past Day" ? (
                        <>
                          <div class="form-check d-flex align-items-center">
                            <Input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="Hour"
                              onClick={radioChange}
                              defaultChecked="true"
                            />
                            <label
                              className="form-check-label"
                              for="Hour"
                              onClick={radioChange}
                            >
                              Hours
                            </label>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {defaultOption == "Past 3 Months" ||
                      defaultOption == "Past Month" ? (
                        <>
                          <div class="form-check d-flex align-items-center">
                            <Input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="Day"
                              onClick={radioChange}
                              //   defaultChecked="true"
                            />
                            <label
                              className="form-check-label"
                              for="Day"
                              onClick={radioChange}
                            >
                              Days
                            </label>
                          </div>
                          <div class="form-check d-flex align-items-center">
                            <Input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="Week"
                              onClick={radioChange}
                              checked={optiononenew === "Week"}
                              defaultChecked="true"
                            />
                            <label
                              className="form-check-label"
                              for="Week"
                              onClick={radioChange}
                            >
                              Weeks
                            </label>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {defaultOption === "Past Year" ||
                      defaultOption == "Custom" ? (
                        <>
                          <div class="form-check d-flex align-items-center">
                            <Input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="Day"
                              onClick={radioChange}
                              defaultChecked="true"
                            />
                            <label
                              className="form-check-label"
                              for="Day"
                              onClick={radioChange}
                            >
                              Days
                            </label>
                          </div>
                          <div class="form-check d-flex align-items-center">
                            <Input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="Week"
                              onClick={radioChange}
                            />
                            <label
                              className="form-check-label"
                              for="Week"
                              onClick={radioChange}
                            >
                              Weeks
                            </label>
                          </div>
                          {defaultOption === "Past Year" ||
                          (defaultOption === "Custom" &&
                            (new Date(parametertwo) - new Date(parameterone)) /
                              (1000 * 60 * 60 * 24) >
                              179) ? (
                            <div class="form-check d-flex align-items-center">
                              <Input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="Months"
                                onClick={radioChange}
                                defaultChecked="true"
                                checked={optiononenew === "Months"}
                              />
                              <label
                                className="form-check-label"
                                for="Months"
                                onClick={radioChange}
                              >
                                Months
                              </label>
                            </div>
                          ) : (
                            ""
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </li>

                    {optiononenew !== "Months" ? (
                      <li
                        className="interdrop"
                        style={{ borderTop: "1px solid #ccc" }}
                      >
                        <div className="d-flex w-100 align-items-center mt-2 justify-content-between">
                          <label className="me-4">Range</label>
                          <div className="fs-26 fw-bold d-flex w-50 water">
                            {optiononenew === "Week" ? (
                              <select
                                name="All meters"
                                id="selector"
                                className="box"
                                onChange={sliderChange}
                                style={{ border: "1px solid #ccc" }}
                              >
                                <option value="1" selected>
                                  1
                                </option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                              </select>
                            ) : (
                              <select
                                name="All meters"
                                id="selector"
                                className="box"
                                onChange={sliderChange}
                                style={{ border: "1px solid #ccc" }}
                              >
                                <option value="1" selected>
                                  1
                                </option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                              </select>
                            )}
                          </div>
                        </div>
                      </li>
                    ) : (
                      ""
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row me-0 pt-4">
          <div className="col-12 col-lg-3 water-100">
            <div className="water-accountList rounded pt-2">
              {sideMenuLoader ? ( // Display the loading spinner when loading is true
                <Spin
                  tip="Loading..."
                  style={{
                    textAlign: "center",
                    width: "100%",
                    minHeight: "350px",
                  }}
                />
              ) : (
               
                <Collapse
                  activeKey={activeKeys}
                  onChange={(key) => handleToggle(key)}
                >
                  {filteredHeadings.map((heading, index) => {
                    const selectedCount =
                      selectedMeters.find((x) => x.code === heading.code)
                        ?.meters.length || 0;
                    return (
                      <Panel
                        header={
                          <div className="d-flex align-items-center justify-content-between w-100 pe-2">
                            {/* Left side: Category Title */}
                            <h5
                              className="mb-0 text-truncate text-width"
                            >
                              {heading.title}
                            </h5>

                            {/* Right side: Grouped Actions */}
                            <div
                              className="d-flex align-items-center"
                              onClick={(e) => e.stopPropagation()}
                            >
                             
                              {/* 2. Selected Count */}
                              {selectedCount > 0 && (
                                <span
                                  style={{
                                    height: "18px",
                                    width: "18px",
                                    borderRadius: "50%",
                                    backgroundColor: "#e6f7ff",
                                    color: "#1890ff",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "11px",
                                    fontWeight: "600",
                                    marginRight: "8px",
                                  }}
                                >
                                  {selectedCount}
                                </span>
                              )}

                              {/* 3. Clear Button */}
                              {selectedCount > 0 && (
                                <span
                                  onClick={() =>
                                    handleClearCategory(heading.code)
                                  }
                                  style={{
                                    color: "#f5222d",
                                    fontSize: "12px",
                                    cursor: "pointer",
                                    fontWeight: 500,
                                    whiteSpace: "nowrap",
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.target.style.textDecoration =
                                      "underline")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.target.style.textDecoration = "none")
                                  }
                                >
                                  Clear
                                </span>
                              )}
                            </div>
                          </div>
                        }
                        key={index.toString()}
                      >
                        <VirtualMeters
                          heading={heading}
                          meters={heading.meters}
                          selectedMeters={selectedMeters}
                          meterColorMap={meterColorMap}
                          handleMeterSelection={handleMeterSelection}
                        />
                        <hr />
                      </Panel>
                    );
                  })}
                </Collapse>
              )}
            </div>
          </div>

          <div
            className="col-12 col-lg-9 water-chartList"
            id="domEl"
            ref={domEl}
          >
            <div className="bg-white pt-4 mt-4">
              <div
                style={{ maxWidth: "100%", margin: "0 auto", height: "500px" }}
                className="line-chart"
              >
                {loading || sideMenuLoader ? ( // Display the loading spinner when loading is true
                  <Spin
                    tip="Loading..."
                    style={{
                      textAlign: "center",
                      width: "100%",
                      minHeight: "350px",
                    }}
                  />
                ) : (
                  <ResponsiveContainer
                    width="100%"
                    height={400}
                    autoHeight
                    debounce={300}
                  >
                    <LineChart
                      data={chartData}
                      margin={{ top: 5, right: 50, left: 20, bottom: 5 }}
                    >
                      {/* X-Axis 0: Rotated Labels */}
                      <XAxis
                        xAxisId="0"
                        dataKey="name"
                        tick={false} // Hide ticks
                        angle={-45} // Rotate the labels by -45 degrees
                        textAnchor="end" // Align the text anchor at the end for better readability
                        tickFormatter={(value, index) =>
                          index % 4 === 0 ? value : ""
                        } // Show label every 4th index
                      />

                      {/* Additional X-Axis 1: Date Formatting */}
                      <XAxis
                        xAxisId="1"
                        dataKey="name"
                        allowDuplicatedCategory={false} // Avoid duplicate categories
                        tick={{ angle: 360, textAnchor: "end" }} // Rotate and align text labels
                        tickFormatter={(value, index) => {
                          const formattedDate = moment(
                            value,
                            "dddd, MMM DD, YYYY hh:mm A",
                          ).format("MMM DD, YYYY");

                          switch (defaultOption) {
                            case "Past Year":
                              return index % 15 === 0 ? formattedDate : "";
                            case "Past 3 Months":
                              return index % 10 === 0 ? formattedDate : "";
                            case "Past Month":
                              return index % 4 === 0 ? formattedDate : "";
                            case "Past Week":
                            case "Past Day":
                              return formattedDate; // Show all labels
                            default:
                              return formattedDate; // Default case, show all formatted dates
                          }
                        }}
                      />

                      {/* Y-Axis: Gallons Label */}
                      <YAxis tickFormatter={(value) => value.toLocaleString()}>
                        <Label
                          value="Gallons"
                          position="insideLeft"
                          angle={-90}
                          style={{
                            textAnchor: "middle",
                            fontSize: "18px",
                            fontWeight: "600",
                          }}
                        />
                      </YAxis>

                      <CartesianGrid stroke="lightGrey" />
                      <Tooltip formatter={(value) => value.toLocaleString()} />
                      <div className="legend-visibility">
                        {/* <Legend /> */}
                      </div>

                      {/* Render lines dynamically based on meter IDs */}
                      {Object.keys(chartData[0] || {})
                        .filter((key) => key !== "name") // Exclude the 'name' key (which is the time label)
                        .map((meterId) => (
                          <Line
                            key={meterId}
                            type="monotone"
                            dataKey={meterId}
                            stroke={meterColorMap[meterId]} // Use assigned color for the meter
                            activeDot={{ r: 5 }}
                            strokeWidth={2}
                          />
                        ))}
                    </LineChart>
                  </ResponsiveContainer>
                )}

                <div className="px-5 d-flex flex-wrap justify-content-start align-items-center mb-1 float-left-new w-100 text-center">
                  {selectedMeters?.map((heading, index) =>
                    heading.meters.map((meterString, meterIndex) => {
                      const [meter_id, register_number] =
                        meterString.split(","); // Split into meter_id and register_number

                      const isSelected = selectedMeters.some(
                        (item) =>
                          item.code === heading.code &&
                          item.meters.includes(
                            `${meter_id},${
                              register_number ? register_number : ""
                            }`,
                          ),
                      );

                      // Get the color for the meter from the color map (based on meter_id)
                      const meterColor = meterColorMap[meter_id] || "#bfbfbf"; // Use meter_id to get the color, fallback to grey

                      return (
                        <div
                          key={`${meter_id}-${meterIndex}`}
                          className="d-flex me-1 mb-2 me-4"
                        >
                          <div
                            style={{
                              width: 10,
                              height: 10,
                              backgroundColor: isSelected
                                ? meterColor
                                : "#bfbfbf",
                              marginRight: 6,
                            }}
                          ></div>
                          <span>
                            {register_number
                              ? `${meter_id},${register_number}`
                              : meter_id}
                          </span>
                        </div>
                      );
                    }),
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Main>
    </>
  );
}
export default WaterMeterReading;
